
import { Options } from 'vue-class-component'
import { Mixins } from 'vue-property-decorator'
import { CardResultMixin } from '../desk/card-result/cardresultmixin'
import { RESULT } from '@/utils/constants'

@Options({})
export default class MultiCardResult extends Mixins(CardResultMixin) {
    get winLabel(): string {
        if (!this.gameResult) return ''
        if (
            this.gameResult.whoWin <= 0 ||
            this.gameResult.whoWin > RESULT.SUPER6
        )
            return ''

        if (this.gameType === 'G002') {
            if (
                this.gameResult.whoWin === RESULT.RED ||
                this.gameResult.whoWin === RESULT.SUPER6
            )
                return '庄赢'
            else if (this.gameResult.whoWin === RESULT.GREEN) return '和局'
            else if (this.gameResult.whoWin === RESULT.BLUE) return '闲赢'
        } else if (this.gameType === 'G003') {
            if (
                this.gameResult.whoWin === RESULT.DRAGON ||
                this.gameResult.whoWin === RESULT.RED
            )
                return '龙赢'
            else if (
                this.gameResult.whoWin === RESULT.GREEN ||
                this.gameResult.whoWin === RESULT.DRAGON_TIGER_TIE
            )
                return '和局'
            else if (
                this.gameResult.whoWin === RESULT.BLUE ||
                this.gameResult.whoWin === RESULT.TIGER
            )
                return '虎赢'
        }

        return ''
    }
}
